import React, { useMemo, useState, useRef } from "react";
import { Box, Card, CardContent, Typography, Grid, Paper, darken } from "@mui/material";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Scrollbar from "react-scrollbars-custom";
import CustomTextField from "../../../Components/common/TextField";

export default function VehicleList({ hideGeofencesVehicle, selectedCatergoryName, selectedGeofenceName }) {
  const selectedDevices = useSelector((state) => state.devices);
  const allVehiclesList = useSelector((state) => state.vehicles);
  const themecolors=useSelector((state)=>state.themeColors)

  const [search, setSearch] = useState("");
  const [visibleCount, setVisibleCount] = useState(20);

  const filteredDevices = useMemo(() => {
    if (!selectedDevices?.data) return [];
    return selectedDevices.data.filter((device) => {
      const matchCategory = selectedCatergoryName
        ? device?.devicetypeLabel?.toLowerCase() === selectedCatergoryName.toLowerCase()
        : true;

      const matchSearch = search
        ? device?.uniqueId?.toLowerCase().includes(search.toLowerCase()) ||
        device?.label?.toLowerCase().includes(search.toLowerCase())
        : true;

      return matchCategory && matchSearch;
    });
  }, [selectedDevices?.data, selectedCatergoryName, search]);

  const vehicleMap = useMemo(() => {
    const map = {};
    allVehiclesList.forEach((v) => {
      map[v.deviceId] = v;
    });
    return map;
  }, [allVehiclesList]);

  const scrollbarRef = useRef(null);
  const handleScroll = ({ scrollTop, scrollHeight, clientHeight }) => {
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setVisibleCount((prev) => Math.min(prev + 20, filteredDevices.length));
    }
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 2 }, backgroundColor: darken(themecolors?.menuActiveBackground, 0.1)||"#0E7A94", minHeight: "70vh" }}>
      <Paper
        elevation={3}
        sx={{
          p: 1,
          mb: 1,
          bgcolor:themecolors?.backgroundColor||"#045266",
          color:themecolors?.textColor|| "white",
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
            borderRadius: "10px",
          }}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <ArrowBackIosNewOutlined
              sx={{ cursor: "pointer" }}
              onClick={hideGeofencesVehicle}
            />
            <Box>
              <Typography variant="body2">{selectedCatergoryName==="N/S"?"Default":selectedCatergoryName}</Typography>
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "14px", sm: "18px" }, fontWeight: "bold" }}
              >
                {selectedGeofenceName}
              </Typography>
            </Box>
          </Box>
          <Box >
            <CustomTextField
              label={"Search"}
              type='search'
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setVisibleCount(20);
              }}
            />
          </Box>
        </Box>
      </Paper>
      <Scrollbar ref={scrollbarRef} onScroll={handleScroll} disableTracksWidthCompensation style={{ height: 38 * 20 }}>
        {filteredDevices.length === 0 ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card
                sx={{
                  backgroundColor:themecolors?.backgroundColor,
                  color:themecolors?.textColor|| "#fff",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 80,
                }}
              >
                <Typography sx={{ fontSize: 16, fontWeight: "bold" }}>No devices found</Typography>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={1}>
            {filteredDevices.slice(0, visibleCount).map((device) => {
              const vehicle = vehicleMap[device.id];
              const licensePlate = vehicle?.vehicleLicensePlate || "-";
              return (
                <Grid item xs={12} key={device.id} sx={{ overflow: "visible" }}>
                  <Card
                    sx={{
                      backgroundColor:themecolors?.backgroundColor|| "#004B5C",
                      color:themecolors?.textColor|| "#fff",
                      borderRadius: "12px",
                      boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      transformOrigin: "center",
                      willChange: "transform",
                      "&:hover": {
                        transform: "scale(0.99)",
                        boxShadow: "0px 8px 12px rgba(0,0,0,0.4)",
                      },
                    }}
                  >
                    <CardContent sx={{ "&:last-child": { paddingBottom: 0, },paddingX:1,paddingY:0 }}>
                      <Grid container alignItems="center" spacing={2} flexWrap={{ xs: "wrap", sm: "nowrap" }}>
                        <Grid item xs={12} sm={4} md={3}>
                          <Box display="flex" gap={2} alignItems="center">
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 40,
                                height: 40,
                                backgroundColor:themecolors?.menuActiveBackground|| "#0A83A1",
                                borderRadius: "50%",
                                border: '1px solid white'
                              }}
                            >
                              <img
                                src={`/assets/category/default/${device?.category || 'default'}.svg`}
                                alt={device?.category || 'default'}
                                width={32}
                                height={32}
                              />
                            </span>

                            <Box>
                              <Typography sx={{ fontSize: 16, fontWeight: 600 }} 
      title={`IMEI`}
                              >{device?.uniqueId}</Typography>

                              <Typography sx={{ fontSize: 16, fontWeight: 600 }}
                                    title={`Vehicle Name`}>{vehicle?.label}</Typography>
                              <Typography title={vehicle?.attributes?.vin || "-"} sx={{
                                fontSize: 13, opacity: 0.8, mt: 0.3, fontStyle: "italic",
                                whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 200,
                              }}>
                                Vin: {vehicle?.attributes?.vin || "-"}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                          <Box display="flex" gap={4}>
                            <Box>
                              <Typography sx={{ fontSize: 13, fontStyle: "italic" }}>Make</Typography>
                              <Typography
                                sx={{
                                  fontSize: 13,
                                  mt: 0.2,
                                  fontWeight: 'bold',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: 150,
                                }}
                                title={vehicle?.attributes?.make || "-"}
                              >
                                {vehicle?.attributes?.make || "-"}
                              </Typography>

                            </Box>
                            <Box>
                              <Typography sx={{ fontSize: 13, fontStyle: "italic" }}>Model</Typography>
                              <Typography sx={{
                                fontSize: 13,
                                mt: 0.2,
                                fontWeight: 'bold',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: 150
                              }}>
                                {vehicle?.model || "-"}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={4} md={6} textAlign={{ xs: "left", sm: "right" }}>
                          <Box display="flex" gap={2} justifyContent={{ xs: "flex-start", sm: "flex-end" }} alignItems="center">
                            <Box>
                              <Typography sx={{ fontSize: 13 }}>Registration</Typography>
                              <Typography title={vehicle?.attributes?.registrationNumber || "-"} sx={{
                                fontSize: 13, fontStyle: "italic", whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: 150
                              }}>
                                # {vehicle?.attributes?.registrationNumber || "-"}
                              </Typography>
                            </Box>


                            {/* <Box
                              sx={{
                                width: 200,
                                height: 65,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  backgroundColor: "white",
                                  borderRadius: "16px",
                                  width: "88%",
                                  height: "70%",
                                  position: "relative",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  boxShadow: "0 0 0 2px #075769, 0 0 0 4px white, 0 0 0 8px #075769",
                                }}
                              >
                                {[
                                  { top: 0, left: 30 },
                                  { top: 0, right: 30 },
                                  { bottom: 0, left: 30 },
                                  { bottom: 0, right: 30 },
                                ].map((pos, i) => (
                                  <Box
                                    key={i}
                                    sx={{
                                      position: "absolute",
                                      width: 4,
                                      height: 4,
                                      borderRadius: "50%",
                                      backgroundColor: "#075769",
                                      ...pos,
                                    }}
                                  />
                                ))}
                                <Typography
                                  variant="h5"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#0c6e8f",
                                    letterSpacing: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: 120
                                  }}
                                  title={`Vehicle License Plate ${licensePlate}`}
                                >
                                  {licensePlate}
                                </Typography>
                              </Box>
                            </Box> */}
                             <Box
      sx={{
        width: 200,
        height: 75,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      title={`Vehicle License Plate ${licensePlate}`}
    >
      <Box
        sx={{
          backgroundColor:themecolors?.textColor|| "white",
          borderRadius: "16px",
          width: "88%",
          height: "70%",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 3,
            border: `2px solid ${darken(themecolors?.menuActiveBackground,0.25)}`,
            borderRadius: "12px",
          }}
        />
        {[
          { top: 2, left: 40 },
          { top: 2, right: 40 },
          { bottom: 2, left: 40 },
          { bottom: 2, right: 40 },
        ].map((pos, i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor:themecolors?.backgroundColor|| "#075769",
              ...pos,
            }}
          />
        ))}
       <Typography
                                  variant="h5"
                                  sx={{
                                    fontWeight: "bold",
                                    color:themecolors?.backgroundColor,
                                    letterSpacing: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: 120
                                  }}
                                  title={`Vehicle License Plate ${licensePlate}`}
                                >
                                  {licensePlate}
                                </Typography>
      </Box>
    </Box>


                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
            {visibleCount >= filteredDevices.length && (
              <Grid item xs={12}>
                <Card
                  sx={{
                    backgroundColor: themecolors?.backgroundColor,
                    color:themecolors?.textColor||"#fff",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 60,
                    mt: 1,
                  }}
                >
                  <Typography sx={{ fontSize: 14, fontWeight: "bold", opacity: 0.8 }}>
                    End of devices
                  </Typography>
                </Card>
              </Grid>
            )}
          </Grid>
        )}
      </Scrollbar>
    </Box>
  );
}
